import React from 'react';
import { Smartphone, KeyRound } from 'lucide-react';

const TeacherLoginForm = ({
  teacherMode,
  onSwitchMode,
  inputAccount,
  onAccountChange,
  inputPassword,
  onPasswordChange,
  teacherCode,
  onCodeChange,
  teacherCodeCountdown,
  teacherCodeSent,
  onSendCode,
  loginError,
}) => {
  return (
    <div className="space-y-4 px-6">
      {/* 账号登录模式切换 */}
      <div className="flex items-center justify-center gap-4 text-sm">
        <label className="flex items-center gap-1.5 cursor-pointer">
          <input
            type="radio"
            checked={teacherMode === 'password'}
            onChange={() => onSwitchMode('password')}
            className="accent-blue-600"
          />
          密码登录
        </label>
        <label className="flex items-center gap-1.5 cursor-pointer">
          <input
            type="radio"
            checked={teacherMode === 'code'}
            onChange={() => onSwitchMode('code')}
            className="accent-blue-600"
          />
          验证码登录
        </label>
      </div>

      <div>
        <label className="block text-xs text-gray-400 mb-1.5">
          手机号/邮箱
        </label>
        <div className="relative">
          <Smartphone
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            size={16}
          />
          <input
            value={inputAccount}
            onChange={(e) => onAccountChange(e.target.value)}
            placeholder={'手机号/邮箱'}
            className="w-full pl-9 pr-4 py-2.5 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {teacherMode === 'password' ? (
        <div>
          <label className="block text-xs text-gray-400 mb-1.5">密码</label>
          <div className="relative">
            <KeyRound
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
              size={16}
            />
            <input
              type="password"
              value={inputPassword}
              onChange={(e) => onPasswordChange(e.target.value)}
              placeholder="请输入密码"
              className="w-full pl-9 pr-4 py-2.5 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      ) : (
        <div>
          <label className="block text-xs text-gray-400 mb-1.5">验证码</label>
          <div className="flex gap-2">
            <input
              value={teacherCode}
              onChange={(e) => onCodeChange(e.target.value)}
              placeholder="请输入验证码"
              className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              onClick={onSendCode}
              disabled={teacherCodeCountdown > 0 || !inputAccount.trim()}
              className={`px-4 py-2.5 rounded-xl text-sm font-medium transition shrink-0 ${
                teacherCodeCountdown > 0 || !inputAccount.trim()
                  ? 'bg-gray-100 text-gray-400'
                  : 'bg-[hsl(216,89%,55%)] text-white hover:bg-[hsl(216,89%,45%)]'
              }`}
            >
              {teacherCodeSent
                ? teacherCodeCountdown > 0
                  ? `${teacherCodeCountdown}s`
                  : '重新获取'
                : '获取验证码'}
            </button>
          </div>
        </div>
      )}

      {loginError && <div className="text-red-500 text-sm">{loginError}</div>}
    </div>
  );
};

export default TeacherLoginForm;
